import dayjs from 'dayjs'

export default {
    props: {
        year: { type: Number, required: true },
        month: { type: Number, required: true },
    },

    computed: {
        weekDays() {
            return Array(7)
                .fill(1)
                .map((day, index) =>
                    dayjs()
                        .day(index + 1)
                        .format('ddd'),
                )
        },

        monthDaysWithoutEndPadding() {
            const monthDaysObject = this.monthDaysObject()

            return [...monthDaysObject.startPadding, ...monthDaysObject.actualDaysWithDates]
        },

        monthDays() {
            const monthDaysObject = this.monthDaysObject()

            return [...monthDaysObject.startPadding, ...monthDaysObject.actualDays, ...monthDaysObject.endPadding]
        },
    },

    methods: {
        monthDaysObject() {
            const startOfCurrentMonth = dayjs().year(this.year).month(this.month).startOf('month')
            const startPadding = Array((startOfCurrentMonth.day() || 7) - 1).fill(null)
            const actualDays = Array(startOfCurrentMonth.daysInMonth())
                .fill(1)
                .map((day, index) => index + 1)
            const actualDaysWithDates = Array(startOfCurrentMonth.daysInMonth())
                .fill(1)
                .map((day, index) => ({
                    day: index + 1,
                    date: dayjs()
                        .set('year', this.year)
                        .set('month', this.month)
                        .set('date', index + 1)
                        .startOf('day'),
                }))
            const endPadding =
                (startPadding.length + actualDays.length) % 7
                    ? Array(7 - ((startPadding.length + actualDays.length) % 7)).fill(null)
                    : []

            return {
                startPadding,
                actualDays,
                actualDaysWithDates,
                endPadding,
            }
        },
    },
}
